import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { Template } from './template';

@Injectable({
    providedIn: 'root'
})
export class CurrentEditTemplateStream extends BehaviorSubject<Template> {
    constructor() {
        super(null);
    }
}
